module.exports = __webpack_public_path__ + "static/media/profil_icon.a1da4e72.svg";